import { EnvironmentProviders, inject } from '@angular/core';
import { TrackWorkflowService, provideWorkflowTracking } from '@anduin/shared';
import {
  INVOICES_STEP_TO_EVENT_TYPE,
  INVOICES_STEP_TO_WORKFLOW,
  InvoicesWorkflowStep,
  InvoicesWorkflowStepMetaDataMap,
} from './invoices-workflow.models';

/**
 * Strongly-typed `TrackWorkflowService` view for the invoices module. `trackWorkflow`
 * narrows `metadata` to the shape declared on `InvoicesWorkflowStepMetaDataMap` for
 * whatever step the caller passes.
 */
export type InvoicesTracker = TrackWorkflowService<InvoicesWorkflowStep, InvoicesWorkflowStepMetaDataMap>;

/**
 * Inject the workflow tracker narrowed to the invoices taxonomy. Use this in place of
 * `inject(TrackWorkflowService)` anywhere in the invoices module that needs
 * `trackWorkflow` — direct injection of `TrackWorkflowService` is blocked by
 * `no-restricted-imports` (see `eslint.config.js`).
 */
export function injectInvoicesTracking(): InvoicesTracker {
  return inject(TrackWorkflowService) as InvoicesTracker;
}

/**
 * Register the invoices module's workflow taxonomy. Call once at app providers so
 * `trackWorkflow(<invoices step>)` resolves at runtime against the shared
 * `TrackWorkflowService`.
 */
export function provideInvoicesWorkflowTracking(): EnvironmentProviders {
  return provideWorkflowTracking<InvoicesWorkflowStep, InvoicesWorkflowStepMetaDataMap>({
    stepToWorkflow: INVOICES_STEP_TO_WORKFLOW,
    stepToEventType: INVOICES_STEP_TO_EVENT_TYPE,
  });
}
